import { DocumentNode, gql } from '@apollo/client'

export const GET_STAFF_LIST: DocumentNode = gql`
    query getStaffList($daycareId: Int) {
        getStaffList(daycareId: $daycareId) {
            email
            userId
            active
            id
            firstname
            lastname
            phone
            address
            city
            zip
            country
            degree
            staffLinks {
                daycareId
                level
                notifReport
                notifNewParent
                notifPushNewParent
                notifUpdateParent
                notifPushUpdateParent
                notifNewStaff
                notifPushNewStaff
                notifConfirmation
                notifPushConfirmation
                notifCancellation
                notifPushCancellation
                notifRequestSlot
                notifPushRequestSlot
                notifEventDays
                notifPushEventDays
                notifRegularSlot
                notifPushRegularSlot
                notifTaskNote
                notifPushTaskNote
                rw_params_daycare
                rw_staffs
                rw_staff_work
                rw_families
                rw_child
                rw_occasional_slot
                rw_request_slot
                rw_regular_slot
                rw_news
                rw_event_days
                rw_closing_days
                w_add_posts
                rw_suggestions
                rw_task_note
                rw_meal
            }
        }
    }
`

export const GET_STAFF: DocumentNode = gql`
    query getStaff($staffId: Int!) {
        getStaff(staffId: $staffId) {
            email
            userId
            active
            id
            firstname
            lastname
            phone
            address
            city
            zip
            country
            degree
            staffLinks {
                daycareId
                level
                notifReport
                notifNewParent
                notifPushNewParent
                notifUpdateParent
                notifPushUpdateParent
                notifNewStaff
                notifPushNewStaff
                notifConfirmation
                notifPushConfirmation
                notifCancellation
                notifPushCancellation
                notifRequestSlot
                notifPushRequestSlot
                notifEventDays
                notifPushEventDays
                notifRegularSlot
                notifPushRegularSlot
                notifTaskNote
                notifPushTaskNote
                rw_params_daycare
                rw_staffs
                rw_staff_work
                rw_families
                rw_child
                rw_occasional_slot
                rw_request_slot
                rw_regular_slot
                rw_news
                rw_event_days
                rw_closing_days
                w_add_posts
                rw_suggestions
                rw_task_note
                rw_meal
            }
        }
    }
`

export const MERGE_TWO_STAFFS: DocumentNode = gql`
    mutation MergeTwoStaffs($oldStaffId: Int!, $newStaffId: Int!, $daycareId: Int!) {
        mergeTwoStaffs(oldStaffId: $oldStaffId, newStaffId: $newStaffId, daycareId: $daycareId)
    }
`
